import { StoreWithAll } from '@/base/constants/Store'

const StoreIntegration = {
  YOUR_INTEGRATION_CLICKED: 'MA Integration - Your Integrations Clicked',
  NEW_INTEGRATION_BUTTON_CLICKED: 'MA Integration - New Integration Button Clicked',
  PROVIDER_CLICKED: 'MA Integration - Provider Clicked',
  ADD_TO_WATCH_LIST: 'MA Integration - Provider App Details - Add to watchlist',
  AppStore: {
    APP_STORE_CONNECT_CLICKED: 'MA Integration - App Store Connect Clicked',
    APP_STORE_CONNECT_START: 'MA Integration - App Store Connect Start',
    INTEGRATION_GUIDE_CLICKED: 'MA Integration - App Store Integration Guide Clicked',
    FIND_ACCESS_TOKEN_CLICKED: 'MA Integration - App Store Find Access Token Clicked',
    STEP_1_ENTER_ACCESS_TOKEN: 'MA Integration - App Store Step 1 Enter Access Token - Next',
    STEP_2_SELECT_ACCOUNTS: 'MA Integration - App Store Step 2 Select Accounts - Next',
    STEP_3_INVITE_MOBILE_ACTION: 'MA Integration - App Store Step 3 Invite MobileAction - Complete',
  },
  GooglePlay: {
    GOOGLE_PLAY_DEVELOPER_CLICKED: 'MA Integration - Google Play Developer Clicked',
    STEP_1_INVITE_MOBILE_ACTION: 'MA Integration - Google Play Step 1 Invite MobileAction - Next Step',
    STEP_2_EMAIL_VERIFICATION: 'MA Integration - Google Play Step 2 Email verification - Send',
    GOOGLE_PLAY_INTEGRATED: 'MA Integration - Google Play Integrated',
  },
}

export const AnalyticsEvents = {
  LOGIN: 'MA Login',
  SIGNUP: 'MA Signup',
  SA_LOGIN: 'SA-Login',
  SA_SIGNUP: 'SA-Signup',
  PAGE_VIEW: 'MA Dashboard Page View',
  VIEW_MORE: 'MA View More button clicked',
  ACTIVATION_LINK_CLICKED: 'MA Activation Link Clicked',

  RELEASE_FREEMIUM_BANNER_CLICK: 'release_freemium_banner_click',

  // new onboarding events below
  ONBOARDING_START: 'MA Onboarding Start',
  ONBOARDING_START_NEXT: 'MA Onboarding Start - Next',
  ONBOARDING_APP_SELECTION_VIEW: 'MA Onboarding Step 1 App Selection - View',
  ONBOARDING_APP_SELECTION_SAVE: 'MA Onboarding Step 1 App Selection - Save',
  ONBOARDING_APP_COMPETITOR_SELECTION_VIEW: 'MA Onboarding Step 2 Competitor Selection - View',
  ONBOARDING_APP_COMPETITOR_SELECTION_SAVE: 'MA Onboarding Step 2 Competitor Selection - Save',
  ONBOARDING_APP_COMPETITOR_TRACK_KEYWORDS_VIEW: 'MA Onboarding Step 4 Track Keywords - View',
  ONBOARDING_COMPLETION: 'MA Onboarding Completion',
  MA_SA_SWITCH: 'MA-SA Switch',
  MA_KEYWORD_TRACKING_AI_GENERATED_GROUP_BUTTON_CLICKED: 'MA Keyword Tracking - AI Generated Group Button Clicked',
  MA_KEYWORD_TRACKING_GENERATE_GROUP_BUTTON_CLICKED: 'MA Keyword Tracking - Generate Group Button Clicked',
  MA_KEYWORD_TRACKING_LIVE_APP_RANKINGS_BUTTON_CLICKED: 'MA Keyword Tracking - See Live app rankings',
  REVENUE_ESTIMATION_TAB: 'MA Market Intel App Analysis - Revenue Estimation',
  DAU_TAB: 'MA Market Intel App Analysis - DAU clicked',
  MAU_TAB: 'MA Market Intel App Analysis - MAU Clicked',
  AUDIENCE_TAB: 'MA Market Intel App Analysis - Audience Geography clicked',
  DOWNLOAD_TAB: 'MA Market Intel App Analysis - Download Estimation clicked',
  DOWNLOAD_CSV: 'MA Download CSV button clicked',
  KEYWORD_TRANSLATION: 'MA Keyword Tracking - Translation Button Clicked',
  ASA_INTEGRATION_CLICKED: 'SA-API Integration Clicked', // needs to be same with search-ads-ui event
  ASA_INTEGRATION_COMPLETED: 'SA-API Integrated', // needs to be same with search-ads-ui event
  APP_INTEGRATION: 'MA APP Integration - Integrate Now button clicked',
  IN_APP_EVENTS_APP_SEARCH: 'MA In Apps Events App Search',
  CPP_BY_APP_APP_SEARCH: 'MA CPP Intelligence - CPP by app - App Search',
  CPP_BY_KEYWORD_KEYWORD_SEARCH: 'MA CPP Intelligence - CPP By Keyword - Keyword Search',
  HEADER_INTEGRATE_MY_APP_CLICKED: 'MA Header - Integrate My App Clicked',
  HEADER_ADD_COMPETITOR_CLICKED: 'MA Header - Add Competitor Clicked',
  HEADER_ADD_COMPETITOR: 'MA Header - Add Competitor',
  HEADER_REMOVE_COMPETITOR: 'MA Header - Remove Competitor',
  HEADER_APP_TRACKED: 'MA Header - App Tracked',
  HEADER_APP_STOP_TRACKED: 'MA Header - App Stop Tracked',
  HEADER_STORE_CHANGED: 'MA Header - Store Changed',
  HEADER_STORE_CHANGED_CLICKED: 'MA Header - Store Changed Clicked',
  HEADER_SHARE_URL_CLICKED: 'MA Header - Share URL Clicked',
  HEADER_VIEW_STORE_CLICKED: 'MA Header - View In App Store Clicked',
  SIDE_MENU_CLICKED: 'MA Side Menu Clicked',
  SIDE_MENU_EXPAND_CLICKED: 'MA Side Menu - Expand clicked',
  SIDE_MENU_COLLAPSE_CLICKED: 'MA Side Menu - Collapse clicked',
  HEADER_TRANSLATION_BUTTON_CLICK: 'MA Header - Translation Button Click',
  HEADER_TRANSLATION_BUTTON_SELECT: 'MA Header - Translation Button Select',
  HEADER_CUSTOM_ALERTS_CLICKED: 'MA Header - Custom Alerts Clicked',
  HEADER_WHATS_NEW_CLICKED: 'MA Header - What\'s New Clicked',
  HEADER_PROFILE_SETTINGS_CLICKED: 'MA Header - Profile Settings Clicked',
  KEYWORD_TRACKING_ADD_KEYWORD_BUTTON_CLICKED: 'MA Keyword Tracking - Add Keyword Button Clicked',
  KEYWORD_TRACKING_UPLOAD_POPUP_VIEW: 'MA Keyword Tracking - Upload Popup View',
  KEYWORD_TRACKING_UPLOAD_BUTTON_CLICKED: 'MA Keyword Tracking - Upload Button Clicked',
  KEYWORD_TRACKING_SORTING_CLICKED: 'MA Keyword Tracking - Sorting Clicked',
  KEYWORD_TRACKING_FILTER_APPLIED: 'MA Keyword Tracking - Filter Applied',
  KEYWORD_TRACKING_TYPE_SELECTED: 'MA Keyword Tracking - Type Selected',
  KEYWORD_TRACKING_DELETE_BUTTON_CLICKED: 'MA Keyword Tracking - Delete Button Clicked',
  KEYWORD_TRACKING_COPY_BUTTON_CLICKED: 'MA Keyword Tracking - Copy Button Clicked',
  KEYWORD_TRACKING_ALERT_BUTTON_CLICKED: 'MA Keyword Tracking - Alert Button Clicked',
  KEYWORD_TRACKING_RELATED_SUGGESTED_KEYWORDS_CLICKED: 'MA Keyword Tracking - Related & Suggested Keywords Button Clicked',
  KEYWORD_TRACKING_RANKING_HISTORY_BUTTON_CLICKED: 'MA Keyword Tracking - Ranking History Button Clicked',
  KEYWORD_TRENDS_SEARCH_SCORE_GRAPH_OPENED: 'MA Keyword Trends - Search Score Graph Clicked',
  COMPETITION_ANALYSIS_STARRED_ONLY_CLICKED: 'MA Keyword Tracking - Competition Analysis - Starred Only Clicked',
  COMPETITION_ANALYSIS_CHECKBOX_CLICKED: 'MA Keyword Tracking - Competition Analysis - Checkbox Clicked',
  COMPETITION_ANALYSIS_SCORE_CHANGED: 'MA Keyword Tracking - Competition Analysis -  Score Changed',
  COMPETITION_ANALYSIS_RANK_CHANGED: 'MA Keyword Tracking - Competition Analysis -  Rank Changed',
  COMPETITION_ANALYSIS_FILTER_APPLIED: 'MA Keyword Tracking - Competition Analysis - Filter Applied',
  RANKING_HISTORY_STARRED_ONLY_CLICKED: 'MA Keyword Tracking - Ranking History - Starred Only Clicked',
  RANKING_HISTORY_CHECKBOX_CLICKED: 'MA Keyword Tracking - Ranking History - Checkbox Clicked',
  RANKING_HISTORY_KEYWORD_FILTER_APPLIED: 'MA Keyword Tracking - Ranking History - Keyword Filter Applied',
  MARKET_INTEL_APP_ANALYSIS_BY_COUNTRY_CLICKED: 'MA Market Intel App Analysis - By Country Clicked',
  MARKET_INTEL_APP_ANALYSIS_BY_APP_CLICKED: 'MA Market Intel App Analysis - By App Clicked',
  MARKET_INTEL_APP_ANALYSIS_SUMMARY_EXPAND_BUTTON_CLICKED: 'MA Market Intel App Analysis - Summary Expand Button Clicked',
  MARKET_INTEL_APP_ANALYSIS_GENERATED: 'MA Market Intel App Analysis - Generated',
  MARKET_INTEL_APP_ANALYSIS_BY_COUNTRY_SORTING_CLICKED: 'MA Market Intel App Analysis - By Country - Sorting Clicked',
  MARKET_INTEL_APP_ANALYSIS_BY_APP_SORTING_CLICKED: 'MA Market Intel App Analysis - By App - Sorting Clicked',
  MARKET_INTEL_STORE_ANALYSIS_DOWNLOAD_BUTTON_CLICKED: 'MA Market Intel Store Analysis - Download Button Clicked',
  MARKET_INTEL_STORE_ANALYSIS_REVENUE_BUTTON_CLICKED: 'MA Market Intel Store Analysis - Revenue Button Clicked',
  IN_APP_EVENTS_SEE_ALL_BUTTON_CLICKED: 'MA In App Events - See All Button Clicked',
  IN_APP_EVENTS_APP_EVENTS_GENERATED: 'MA In App Events - App Events - Generated',
  IN_APP_EVENTS_VIEW_EVENT_IN_STORE_CLICKED: 'MA In App Events - View Event in Store Clicked',
  IN_APP_EVENTS_EVENT_PREVIEW_CLICKED: 'MA In App Events - Event Preview Clicked',
  PROMOTIONAL_CONTENT_SEE_ALL_BUTTON_CLICKED: 'MA Promotional Content - See All Button Clicked',
  PROMOTIONAL_CONTENT_APP_EVENTS_GENERATED: 'MA Promotional Content - App Events - Generated',
  PROMOTIONAL_CONTENT_EVENT_PREVIEW_CLICKED: 'MA Promotional Content - Event Preview Clicked',
  APP_UPDATE_TIMELINE_TYPE_SELECTED: 'MA App Update Timeline - Type Selected',
  APP_UPDATE_TIMELINE_EXPAND_BUTTON_CLICKED: 'MA App Update Timeline - Expand Button Clicked',
  APP_UPDATE_TIMELINE_APP_ICON_VIEW: 'MA App Update Timelime - App Icon View',
  VISIBILITY_REPORT_GENERATED: 'MA Visibility Report - Generated',
  VISIBILITY_REPORT_LOCALIZATION_PERFORMANCE_FILTER_APPLIED: 'MA Visibility Report - Localization Performance - Filter Applied',
  LOCALIZATION_EXPAND_BUTTON_CLICKED: 'MA Localization - Expand Button Clicked',
  LOCALIZATION_GENERATED: 'MA Localization - Generated',
  CATEGORY_RANKINGS_GENERATED: 'MA Category Rankings - Generated',
  REVIEWS_GIVE_ANSWER_CLICKED: 'MA Reviews - Give an Answer Clicked',
  REVIEWS_GIVE_ANSWER_COMPLETED: 'MA Reviews - Give an Answer Completed',
  REVIEWS_ALL_REVIEWS_VIEW_APPLIED: 'MA Reviews - Reviews All Reviews View Applied',
  REVIEWS_REPLIED_REVIEWS_VIEW_APPLIED: 'MA Reviews - Reviews Replied Reviews View Applied',
  REVIEWS_NOT_REPLIED_REVIEWS_VIEW_APPLIED: 'MA Reviews - Reviews Not Replied Reviews View Applied',
  REVIEWS_REVIEW_COUNT_CLICKED: 'MA Reviews - Review Count Clicked',
  CREATIVE_MONITORING_VIEW_SS_HISTORY_CLICKED: 'MA Creative Monitoring - View SS History Clicked',
  CREATIVE_MONITORING_TYPE_SELECTED: 'MA Creative Monitoring - Type Selected',
  CREATIVE_MONITORING_ALL_ASSETS_BUTTON_CLICKED: 'MA Creative Monitoring - All Assests Button Clicked',
  CREATIVE_MONITORING_ONLY_ICONS_BUTTON_CLICKED: 'MA Creative Monitoring - Only Icons Button Clicked',
  ASO_REPORT_COMPARE_WITH_CLICKED: 'MA ASO Report - Compare With Clicked',
  ASO_REPORT_SORTING_CLICKED: 'MA ASO Report - Sorting Clicked',
  ASO_REPORT_FILTER_APPLIED: 'MA ASO Report - Filter Applied',
  SA_SEARCH_RESULT_APP_FILTER_APPLIED: 'MA SA Intel - Search Result / App - Filter Applied',
  SA_SEARCH_RESULT_APP_SORTING_CLICKED: 'MA SA Intel - Search Result / App - Sorting Clicked',
  SA_SEARCH_RESULT_KEYWORD_SORTING_CLICKED: 'MA SA Intel - Search Result / Keyword - Sorting Clicked',
  SA_SEARCH_RESULT_KEYWORD_KEYWORD_SEARCHED: 'MA SA Intel - Search Result / keyword (new keyword searched)',
  SA_SEARCH_RESULT_COMPETITOR_UNIQUE_KEYWORDS_CLICKED: 'MA SA Intel - Search Result / Competitor - Unique Keywords Clicked',
  SA_SEARCH_RESULT_COMPETITOR_MUTUAL_KEYWORDS_CLICKED: 'MA SA Intel - Search Result / Competitor - Mutual Keywords Clicked',
  SA_SEARCH_RESULT_COMPETITOR_COMPARISON_GENERATED: 'MA SA Intel - Search Result / Competitor - Comparison generated',
  SA_TOP_ADVERTISERS_SORTING_CLICKED: 'MA SA Intel - Top Advertisers - Sorting Clicked',
  SA_TODAY_TAB_SORTING_CLICKED: 'MA SA Intel - Today Tab - Sorting Clicked',
  SA_SEARCH_TAB_SORTING_CLICKED: 'MA SA Intel - Search Tab - Sorting Clicked',
  SA_PRODUCT_PAGES_SORTING_CLICKED: 'MA SA Intel - Product Pages - Sorting Clicked',
  SA_CPP_INTEL_CPP_URL_CLICKED: 'MA SA Intel CPP Intelligence - CPP URL Clicked',
  SA_CPP_INTEL_CREATIVES_DETAIL_CLICKED: 'MA SA Intel CPP Intelligence - CPP Creatives Detail Clicked',
  SA_CPP_INTEL_CPP_APP_ACTIVE_COUNTRIES_SELECTED: 'MA SA Intel CPP Intelligence - CPP by App - Active Countries Selected',
  SA_CPP_INTEL_CPP_APP_SORTING_CLICKED: 'MA SA Intel CPP Intelligence - CPP by App - Sorting Clicked',
  SA_CPP_INTEL_CPP_APP_KEYWORD_CLICKED: 'MA SA Intel CPP Intelligence - CPP by App - Keyword Clicked',
  SA_CPP_INTEL_CPP_KEYWORD_SORTING_CLICKED: 'MA SA Intel CPP Intelligence - CPP by Keyword - Sorting Clicked',
  SA_CPP_INTEL_CPP_KEYWORD_ALL_VIEW_APPLIED: 'MA SA Intel CPP Intelligence - CPP by Keyword - All View Applied',
  SA_CPP_INTEL_CPP_KEYWORD_ONLY_DEFAULT_VIEW_APPLIED: 'MA SA Intel CPP Intelligence - CPP by Keyword - Only Default View Applied',
  SA_CPP_INTEL_CPP_KEYWORD_ONLY_CPP_VIEW_APPLIED: 'MA SA Intel CPP Intelligence - CPP by Keyword - Only CPP View Applied',
  SA_CPP_INTEL_CPP_KEYWORD_CATEGORY_CLICKED: 'MA SA Intel CPP Intelligence - CPP by Keyword - Category Clicked',
  SA_CPP_INTEL_CPP_KEYWORD_APP_CLICKED: 'MA SA Intel CPP Intelligence - CPP by Keyword - App Clicked',
  SA_CPP_INTEL_CPP_CATEGORY_APP_CLICKED: 'MA SA Intel CPP Intelligence - CPP by Category - App Clicked',
  SA_CPP_INTEL_CPP_CATEGORY_SORTING_CLICKED: 'MA SA Intel CPP Intelligence - CPP by Category - Sorting Clicked',
  SA_CPP_INTEL_CPP_AD_NETWORK_APP_CLICKED: 'MA SA Intel CPP Intelligence - CPP on Ad Networks - App clicked',
  SA_CPP_INTEL_CPP_AD_NETWORK_ICON_CLICKED: 'MA SA Intel CPP Intelligence - CPP on Ad Networks - Ad Network icon clicked',
  SA_CPP_METRICS_CHECKBOX_CLICKED: 'MA SA Intel CPP Metrics - Checkbox Clicked',
  APP_PROFILE_EXPORT_PDF_CLICKED: 'MA App Profile - Export PDF clicked',
  APP_PROFILE_DETAIL_CLICKED: 'MA App Profile Detail Clicked',
  KEYWORD_TRACKED: 'MA Keyword Tracked',
  SCREENSHOT_PREVIEW_CLICKED: 'MA Screenshot Preview Clicked',
  VISIBILITY_SCORE_CLICKED: 'MA Visibility Score Clicked',
  CHART_TOGGLE_CLICKED: 'MA Chart Toggle Clicked',
  ASA_ICON_CLICKED: 'MA ASA Icon Clicked',
  SEARCH_SCORE_ICON_CLICKED: 'MA Search Score Icon Clicked',
  StoreIntegration,
  SCHEDULE_DEMO_BUTTON_CLICKED: 'MA Schedule a Demo clicked',
  KEYWORD_GROUP_SELECTION: 'MA Keyword Group Selection',
  KEYWORD_GROUP_CREATION: 'MA Keyword Group Creation',
  KEYWORD_GROUP_COPY: 'MA Keyword Group Copy',
  APP_STORE_INTEGRATION_NOTIFY_ME: 'MA App Store Integration - Notify Me',
  COMPETITOR_KEYWORDS_SORTING_CLICKED: 'MA Competitor Keywords - Sorting Clicked',

  // Competitor Slot Selection
  COMPETITOR_SLOT_SELECTED: 'MA Competitor Slot Selection',

  // Compass/Explore page
  COMPASS_EXPLORE_SECTION_NAVIGATION_BUTTON_CLICKED: 'MA Compass Explore - Page navigation button clicked',
  COMPASS_EXPLORE_SECTION_EXPAND_COLLAPSE_BUTTON_CLICKED: 'MA Compass Explore - Chevron up & down button clicked',
  COMPASS_EXPLORE_NAVIGATION_BADGE_CLICKED: 'MA Compass Explore - Navigation Banner clicked',
  COMPASS_EXPLORE_PDF_EXPORT_BUTTON_CLICKED: 'MA Compass Explore - PDF Export button clicked',
  COMPASS_EXPLORE_CATEGORY_RANKING_DAILY_RANKING_TAB_CLICKED: 'MA Compass Explore - Category Ranking - Daily Rankings tab clicked',
  COMPASS_EXPLORE_CATEGORY_RANKING_RANKING_HISTORY_TAB_CLICKED: 'MA Compass Explore - Category Ranking - Ranking History Chart tab clicked',
  COMPASS_EXPLORE_CREATIVE_EXPLORER_ICON_TAB_CLICKED: 'MA Compass Explore - Creative Explorer - Icon tab clicked', // Formerly Visualization
  COMPASS_EXPLORE_CREATIVE_EXPLORER_SCREENSHOTS_TAB_CLICKED: 'MA Compass Explore - Creative Explorer - Screenshots tab clicked',
  COMPASS_EXPLORE_CREATIVE_EXPLORER_PREVIEW_VIDEO_TAB_CLICKED: 'MA Compass Explore - Creative Explorer - Preview Video tab clicked',
  COMPASS_EXPLORE_CREATIVE_EXPLORER_IN_APP_EVENTS_TAB_CLICKED: 'MA Compass Explore - Creative Explorer - In App Events tab clicked',
  COMPASS_EXPLORE_APP_VISIBILITY_VISIBILITY_MAP_TAB_CLICKED: 'MA Compass Explore - App Visibility - Visibility Map tab clicked',
  COMPASS_EXPLORE_APP_VISIBILITY_HISTORICAL_VISIBILITY_TAB_CLICKED: 'MA Compass Explore - App Visibility - Historical Visibility Chart tab clicked',
  COMPASS_EXPLORE_APP_VISIBILITY_LOCALIZATION_PERFORMANCE_TAB_CLICKED: 'MA Compass Explore - App Visibility - Localization Performance tab clicked',
  COMPASS_EXPLORE_METADATA_TITLE_TAB_CLICKED: 'MA Compass Explore - Metadata - Title tab clicked',
  COMPASS_EXPLORE_METADATA_SUBTITLE_TAB_CLICKED: 'MA Compass Explore - Metadata - Subtitle tab clicked',
  COMPASS_EXPLORE_METADATA_APP_STORE_CONNECT_KEYWORDS_TAB_CLICKED: 'MA Compass Explore - Metadata - App Store Connect Keywords tab clicked',
  COMPASS_EXPLORE_METADATA_DESCRIPTION_TAB_CLICKED: 'MA Compass Explore - Metadata - Description tab clicked',
  COMPASS_EXPLORE_FEATURING_ANALYSIS_TOTAL_NUMBER_OF_FEATURING_TAB_CLICKED: 'MA Compass Explore - Featuring Analysis - Total Number of Featuring tab clicked',
  COMPASS_EXPLORE_FEATURING_ANALYSIS_FEATURING_GROWTH_TAB_CLICKED: 'MA Compass Explore - Featuring Analysis - Featuring Growth tab clicked',

  // Compass/Trace page
  COMPASS_TRACE_MULTIPLE_KPI_ANALYSIS_BUTTON_CLICKED: 'MA Compass Trace - Multiple KPI analysis button clicked',
  COMPASS_TRACE_COMPETITORS_KPI_ANALYSIS_BUTTON_CLICKED: 'MA Compass Trace - KPI analysis for competitors button clicked',
  COMPASS_TRACE_COUNTRIES_KPI_ANALYSIS_BUTTON_CLICKED: 'MA Compass Trace - KPI analysis for countries button clicked',
  COMPASS_TRACE_SPIKE_CLICKED: 'MA Compass Trace - Spike clicked',
  COMPASS_TRACE_METRIC_SELECTION_BUTTON_CLICKED: 'MA Compass Trace - KPI selected',
  COMPASS_TRACE_DATE_RANGE_CHANGED: 'MA Compass Trace - Data range selection',
  COMPASS_TRACE_DENSE_VIEW_CHANGED: 'MA Compass Trace - Dense view toggle clicked',
  COMPASS_TRACE_LAYOUT_CHANGED: 'MA Compass Trace - Chart view changed',
  COMPASS_TRACE_ACTIVITIES_VIEW_CHANGED: 'MA Compass Trace - Activities view changed',
  COMPASS_TRACE_ACTIVITY_CLICKED: 'MA Compass Trace - Activity clicked',
  COMPASS_TRACE_NAVIGATE_BUTTON_CLICKED: 'MA Compass Trace - Navigate button clicked',
  COMPASS_TRACE_POPUP_PAGINATION_CHANGED: 'MA Compass Trace - Popup pagination changed',
  COMPASS_TRACE_DOWNLOAD_BUTTON_CLICKED: 'MA Compass Trace - Download Button Clicked',

  // Compass/Impact page
  COMPASS_IMPACT_KPI_SELECTED: 'MA Compass Impact - KPI selected',
  COMPASS_IMPACT_TIMELINE_SELECTED: 'MA Compass Impact - Timeline Selected',
  COMPASS_IMPACT_ACTIVITY_TAB_CLICKED: 'MA Compass Impact - Selected Activity Tab clicked',
  COMPASS_IMPACT_UA_ACTIVITY_CLICKED: 'MA Compass Impact - UA Activity Clicked',
  COMPASS_IMPACT_CHART_EXPORTED: 'MA Compass Impact - Before After Chart exported',

  // Chart Annotaitons
  CHART_ANNOTATIONS_SHOW_BUTTON_CLICKED: 'MA Show Annotations button clicked',
  CHART_ANNOTATIONS_HIDE_ANNOTATION_BUTTON_CLICKED: 'MA Hide Annotations button clicked',
  CHART_ANNOTATIONS_POPUP_BUTTON_CLICKED: 'MA Annotations popup button clicked',
  CHART_ANNOTATIONS_ADD_NEW_ANNOTATION_BUTTON_CLICKED: 'MA Add New Annotation button clicked',
  CHART_ANNOTATIONS_ANNOTATION_CREATED: 'MA Annotation created',

  // Ratings
  RATINGS_TOTAL_RATINGS_TAB_CLICKED: 'MA Ratings - Total Ratings tab clicked',
  RATINGS_DAILY_RATINGS_TAB_CLICKED: 'MA Ratings - Daily Ratings tab clicked',
  RATINGS_COUNTRY_BREAKDOWN_SEE_MORE_CLICKED: 'MA Ratings - Country Breakdown See More clicked',
  RATINGS_VERSION_BREAKDOWN_SEE_MORE_CLICKED: 'MA Ratings - Version Breakdown See More clicked',
  RATINGS_GRAPH_DATE_OPTION_CHANGED: 'MA Ratings - Graph date option changed - with property',
  RATINGS_GRAPH_VIEW_OPTION_CHANGED: 'MA Ratings - Graph view option changed - with property',

  // Keyword Translator
  KEYWORD_TRANSLATOR_TRANSLATE_BUTTON_CLICKED: 'MA Keyword Translator - Translate button clicked',
  KEYWORD_TRANSLATOR_COUNTRY_FLAG_CLICKED: 'MA Keyword Translator - Country flag clicked',
  KEYWORD_TRANSLATOR_LANGUAGE_CHANGED: 'MA Keyword Translator - Language changed',

  // Metadata Optimizer
  METADATA_OPTIMIZER_TEST_BUTTON_CLICKED: 'MA Metadata Optimizer - Test button clicked',
  METADATA_OPTIMIZER_GET_MY_TITLE_BUTTON_CLICKED: 'MA Metadata Optimizer - Get My Title button clicked',
  METADATA_OPTIMIZER_GET_MY_SUBTITLE_BUTTON_CLICKED: 'MA Metadata Optimizer - Get My Subtitle button clicked',
  METADATA_OPTIMIZER_GET_MY_KEYWORDS_BUTTON_CLICKED: 'MA Metadata Optimizer - Get My Keywords button clicked',
  METADATA_OPTIMIZER_GET_MY_DESCRIPTION_BUTTON_CLICKED: 'MA Metadata Optimizer - Get My Description button clicked',
  METADATA_OPTIMIZER_CHARACTER_ANALYSIS_BUTTON_CLICKED: 'MA Metadata Optimizer - Character Analysis button clicked',
  METADATA_OPTIMIZER_KEYWORD_DENSITY_BUTTON_CLICKED: 'MA Metadata Optimizer - Keyword Density button clicked',

  // Featured Apps
  FEATURED_APPS_DATE_SELECTED: 'MA Featured Apps - Date selected',
  FEATURED_APPS_APP_SEARCHED: 'MA Featured Apps - App searched',

  // My Apps
  MY_APPS_BUTTON_CLICKED: 'MA My Apps - My Apps button clicked',
  MY_APPS_MANAGE_MY_APPS_CLICKED: 'MA My Apps - Manage My Apps clicked',
  MY_APPS_SHOW_INTEGRATED_CHECKBOX_CLICKED: 'MA My Apps - Show Integrated checkbox clicked',
  MY_APPS_STORE_CHANGED: 'MA My Apps - Store change',
  MY_APPS_MANAGE_MY_APPS_APP_SELECTED: 'MA My Apps - Manage My Apps - App selected',
  MY_APPS_MANAGE_MY_APPS_REMOVE_AN_APP: 'MA My Apps - Manage My Apps - Remove an app',
  MY_APPS_MANAGE_MY_APPS_INTEGRATE_AN_APP: 'MA My Apps - Manage My Apps - Integrate an app',
  MY_APPS_MANAGE_MY_APPS_REMOVE_A_COMPETITOR: 'MA My Apps - Manage My Apps - Remove a competitor',
  MY_APPS_MANAGE_MY_APPS_REMOVE_KEYWORDS: 'MA My Apps - Manage My Apps - Remove the keywords',

  // Page Filters
  APP_SELECTION: 'MA App Selection',
  COUNTRY_SELECTION: 'MA Country Selection',
  CATEGORY_SELECTION: 'MA Category Selection',
  DEVICE_SELECTION: 'MA Device Selection',
  DATE_SELECTION: 'MA Date Selection',
  KEYWORD_TRACK_ALL_BUTTON_CLICKED: 'MA Track All button clicked',

  // Competitor Group
  COMPETITOR_GROUP_CREATED: 'MA Competitor Group - New Group Created',
  COMPETITOR_GROUP_REMOVED: 'MA Competitor Group - Remove Group Button Clicked',

  // Taxonomy
  APP_TAXONOMY_FILTERED: 'MA Taxonomy Filtering - App Taxonomy Applied',
  GAME_TAXONOMY_FILTERED: 'MA Taxonomy Filtering - Game Taxonomy Applied',

  // Smart Tracking
  SMART_TRACKING_ADD_BUTTON_CLICKED: 'MA Smart Track Component - Add button',

  // Loom Videos
  HEADER_LOOM_VIDEO_ICON_CLICK: 'MA Header Loom Video Icon Click',
  IN_PAGE_LOOM_VIDEO_ICON_CLICK: 'MA In Page Loom Video Icon Click',
}

export const AnalyticsProps = {
  PLATFORM: 'platform',
  REGISTRATION_DATE: 'registrationDate',
  USER_ID: 'userId',
  ACCOUNT_ID: 'accountId',
  LOGIN_BY: 'Login By',
  // email and product should be lower case for hubspot
  EMAIL: 'email',
  PRODUCT: 'product',
  FIRST_LOGIN: 'firstLogin',
  LAST_LOGIN: 'lastLogin',
  LOGIN_COUNT: 'Login Count',
  PAGE: 'Page',
  ACCESS: 'Access',
  DESTINATION_PAGE: 'Destination Page',
  TAB: 'Tab',
  DESTINATION_TAB: 'Destination Tab',
  PREVIOUS_PAGE: 'Previous Page',
  APP_NAME: 'App Name',
  APP_STORE: 'App Store',
  APP_ID: 'App ID',
  DESTINATION_COUNTRY: 'Destination County',
  NUMBER_OF_KEYWORDS: 'Number of Keywords',
  PREVIOUS_APP_NAME: 'Previous App Name',
  PREVIOUS_APP_ID: 'Previous App ID',
  START_DATE: 'Start Date',
  END_DATE: 'End Date',
  COUNTRY_NAME: 'Country Name',
  COUNTRY_CODE: 'Country Code',
  PREVIOUS_COUNTRY_NAME: 'Previous Country Name',
  PREVIOUS_COUNTRY_CODE: 'Previous Country Code',
  CATEGORY_NAMES: 'Category Names',
  COMPARED_APPS: 'Compared Apps',
  KEYWORD: 'Keyword',
  MENU: 'Menu',
  SUB_MENU: 'Sub Menu',
  SECTION: 'Section',
  TYPE: 'Type',
  OPTION: 'Option',
  COLOR: 'Color',
  COUNT: 'Count',
  COUNTRY: 'Country',
  LANGUAGE: 'Language',
  PRODUCT_FAMILY: 'Product Family',
  CSV_DOWNLOAD_LOCATION: 'CSV Download Location',
  DATE_VIEW: 'Date View',
  GRAPH_VIEW: 'Graph View',
  STORE: 'Store',
  DEVICE: 'Device',
  CATEGORY: 'Category',
  LOCATION: 'Location',
  VALUE: 'Value',
  REMOVE_TYPE: 'Remove Type',
  SA_USER_ID: 'UserId',
  SA_LOGIN_PRODUCT: 'LoginProduct',
  SA_LOGIN_BY: 'LoginBy',
  SA_SIGNUP_PRODUCT: 'SignupProduct',
  SA_SIGNUP_BY: 'SignupBy',
  MAIN_TRACK_ID: 'Main TrackId',
  COMPETITOR_TRACK_ID_LIST: 'Competitor TrackId List',
}

export const ASAIntegrationPlace = {
  ONBOARDING: 'MA_ONBOARDING',
  KW_TRACK_CR_TTR: 'KEYWORD_TRACK_CR_TTR',
  SA_INTEL_BY_APP: 'SA_INTEL_BY_APP',
  SA_INTEL_BY_KW: 'SA_INTEL_BY_KEYWORD',
  SA_INTEL_BY_COMPETITOR: 'SA_INTEL_BY_COMPETITOR',
  SA_INTEL_TOP_ADV: 'SA_INTEL_TOP_ADVERTISERS',
  SA_INTEL_CPP_METRICS: 'SA_INTEL_CPP_METRICS',
  SA_INTEL_CPP_INTELLIGENCE: 'SA_INTEL_CPP_INTEL',
  EXC_COMPETITORS: 'EXCLUSIVE_COMPETITORS',
}

export const SEGMENTED_DATE_VIEW = Object.freeze({
  DAILY: 'Daily',
  WEEKLY: 'Weekly',
  MONTHLY: 'Montly',
})

export const GRAPH_VIEW = Object.freeze({
  COLUMN: 'Stack Column',
  AREA: 'Stack Area',
})

export const STORE_OPTION = Object.freeze({
  [StoreWithAll.All]: 'All',
  [StoreWithAll.Ios]: 'App Store',
  [StoreWithAll.Play]: 'Google Play',
})
